<div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 bg-white border-bottom shadow-sm">
  <div class="container">
    <img class="my-0 mr-md-auto" src="../assets/img/vit_connect_logo.png" alt="VIT Connect Logo" style="height: 35px">
  </div>
</div>

<router-outlet></router-outlet>
